import styled from 'styled-components';
import { COLORS } from '../../../values/colors';


export const FooterContainer = styled.footer`
  background-color:${COLORS.darkGray};
  border-top: 1px solid ${COLORS.white};
  padding-top: 3rem;
  padding-bottom: 3rem;
  width: 100%; 
  content-align: center;
  justify-content: center;
  text-align: center;
`;

export const Text = styled.p`
  color: ${COLORS.white};
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    text-decoration: underline solid white;
  }
`;

export const SocialMediaIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: center;
  font-size: 0.75rem;
  gap: 1.5rem;
  padding-top: 1rem;
`;
